import { useMemo } from 'react'
import styled from 'styled-components'

import { QuickBuyButton } from '@root/features/trade/swap/ui/desktop'

import { mapToQuickBuySection } from '../../atoms/explore-table'

import type { ExploreTableFeedType } from '../../atoms/explore-table'
import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
  feedType: ExploreTableFeedType
}

export const ExploreTableBuyCell: React.FC<Props> = ({ pair, feedType }) => {
  const section = useMemo(() => mapToQuickBuySection(feedType), [feedType])
  return (
    <Root>
      <QuickBuyButton pair={pair} withIcon withLabel section={section} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  place-items: center;
`
